import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class SectionPlainTitle extends Component {
  static propTypes = {
    level: PropTypes.number,
    children: PropTypes.node,
    className: PropTypes.string
  };

  render() {
    const {
      level = 2,
      className = "section-plain-title",
      children
    } = this.props;

    return React.createElement(
      `h${level}`,
      { className: className },
      children
    );
  }
}


// WEBPACK FOOTER //
// ./modules/Common/components/SectionPlainTitle.js